export const isString = (x: unknown): x is string => 'string' === typeof x;
export const isNumber = (x: unknown): x is number => 'number' === typeof x;
export const isBoolean = (x: unknown): x is boolean => 'boolean' === typeof x;
export const isArray = (x: unknown): x is Array<any> => Array.isArray(x);
export const isObject = (x: unknown): x is Object => 'object' === typeof x && !!x && !isArray(x);
export const isFunction = (x: unknown): x is Function => 'function' === typeof x;
export const isPromiseLike = (x: unknown): x is PromiseLike<unknown> => x instanceof Promise || isFunction((x as PromiseLike<unknown>)?.then);

export const isNotUndefined = <T>(x: T): x is Exclude<T, undefined> => x !== undefined;
export const isNotNull = <T>(x: T): x is Exclude<T, null> => x !== null;

export const isNonEmptyString = (x: unknown): x is string => isString(x) && !!x;
export const isStringArray = (x: unknown): x is string[] => isArray(x) && x.every(isString);

/** Typeguard to check if an element is a HTMLElement */
export const isHTMLElement = (x: unknown): x is HTMLElement => x instanceof HTMLElement || ((x as Element)?.nodeType === Node.ELEMENT_NODE && isFunction((x as HTMLElement)?.click));
/** Typeguard to check if an element is a HTMLStyleElement */
export const isHTMLStyleElement = (x: unknown): x is HTMLStyleElement => isHTMLElement(x) && x.tagName === 'STYLE';
/** Typeguard to check if an element is a HTMLIFrameElement */
export const isHTMLIFrameElement = (x: unknown): x is HTMLIFrameElement => isHTMLElement(x) && x.tagName === 'IFRAME';
/** Typeguard to check if an element is a HTMLVideoElement */
export const isHTMLVideoElement = (x: unknown): x is HTMLVideoElement => isHTMLElement(x) && x.tagName === 'VIDEO';
